<template>
  <div>
    <!-- Media -->

    <b-media class="mb-2">
      <template #aside>
        <b-avatar
          ref="previewEl"
          :src="
                  userData.companyLogo
                    ? userData.companyLogo.startsWith('data:image')
                      ? userData.companyLogo
                      : `data:image/jpeg;base64,${userData.companyLogo}`
                    : ''
                "
          :text="avatarText(userData.name)"
          :variant="`light-${resolveUserRoleVariant(userData.role)}`"
          size="90px"
          rounded
        />
      </template>
      <h4 class="mb-1">
        {{ userData.name }}
      </h4>

      <div class="d-flex flex-wrap">
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-primary"
          class="btn-icon ml-0"
          @click="$refs.refInputEl.click()"
        >
          <input
            ref="refInputEl"
            type="file"
            class="d-none"
            @input="inputImageRenderer"
          />

          <feather-icon icon="EditIcon" />
        </b-button>
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-secondary"
          class="btn-icon ml-0"
          @click="deletePic"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </div>
    </b-media>

    <!-- User Info: Input Fields -->
    <b-form @submit="onSubmit">
      <b-row>
        <!-- Field:  -->
        <b-col cols="12" md="6">
          <b-form-group label="Company" label-for="company">
            <b-form-input id="company" v-model="userData.name" />
          </b-form-group>
        </b-col>

        <!-- Field: Email -->
        <b-col cols="12" md="6">
          <b-form-group label="Email" label-for="email">
            <b-form-input id="email" v-model="userData.email" type="email" />
          </b-form-group>
        </b-col>

        <!-- Field: Status -->

        <!-- Field:  -->
        <b-col cols="12" md="6">
          <b-form-group label="Contact" label-for="contact">
            <b-form-input id="contact" v-model="userData.contactName" />
          </b-form-group>
        </b-col>

        <!-- Field:  -->

        <b-col cols="12" md="6">
          <b-form-group label="Phone" label-for="phone">
            <b-form-input id="phone" v-model="userData.phone" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Country" label-for="country">
            <b-form-input id="country" v-model="userData.country" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="City" label-for="city">
            <b-form-input id="city" v-model="userData.city" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="State" label-for="state">
            <b-form-input id="state" v-model="userData.state" />
          </b-form-group>
        </b-col>
        
          <b-col cols="12" md="6">
          <b-form-group label="Address" label-for="address">
            <b-form-input id="address" v-model="userData.address" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Description" label-for="description">
            <b-form-textarea
              rows="3"
              max-rows="6"
              id="description"
              v-model="userData.description"
            />
          </b-form-group>
        </b-col>
      
      </b-row>

      <!-- Action Buttons -->
      <b-button
        variant="success"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        Save
      </b-button>

      <!--   <b-button
      variant="outline-secondary"
      type="reset"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Reset
    </b-button>-->
    </b-form>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import useUsersList from "../company-list/useCompanyList";
import store from "@/store";
import router from "@/router";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { Vue } from "vue-property-decorator";

export default {
  components: {
    BButton,
    ToastificationContent,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    BFormTextarea,
  },
  data() {
    return {
      file: null,
    };
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  directives: {
    Ripple,
  },
  methods: {
    deletePic() {
      store
        .dispatch("company/deletePic", {
          id: this.userData.id,
        })
        .then((response) => {
          this.userData.companyLogo = "";
        })
        .catch((error) => {
          for (const [key, value] of Object.entries(
            error.response.data.errors
          )) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "error",
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: value,
              },
            });
          }
        });
    },
  },
  setup(props) {
    const { resolveUserRoleVariant } = useUsersList();

    const roleOptions = [
      { roleName: "Administrator", roleId: 1 },
      { roleName: "AppUser", roleId: 2 },
    ];

    const onSubmit = (event) => {
      event.preventDefault();
      const data = {
        id: props.userData.id,
        name: props.userData.name,
        description: props.userData.description,
        contactName: props.userData.contactName,
        email: props.userData.email,
        phone: props.userData.phone,
        address: props.userData.address,
        state: props.userData.state,
        country: props.userData.country,
        city: props.userData.city,
        isDeleted: props.userData.isDeleted,
      };

      store
        .dispatch("company/editUser", data)
        .then((response) => {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: "User updated successfully",
              icon: "AlertTriangleIcon",
              variant: "success",
            },
          });
          router.push("/apps/companies/list").catch(() => {});
          // router.go("/apps/users/list").catch(() => {});
        })
        .catch((error) => {
          for (const [key, value] of Object.entries(
            error.response.data.errors
          )) {
            Vue.$toast({
              component: ToastificationContent,
              props: {
                title: "error",
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: value,
              },
            });
          }

          if (error.response.status === 404) {
            skillsData.value = undefined;
          }
        });
    };

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        // eslint-disable-next-line no-param-reassign

        props.userData.companyLogo = base64;

        // console.log("base64",base64);

        store
          .dispatch("company/addPhoto", {
            id: props.userData.id,
            base64: refInputEl.value.files[0],
          })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            for (const [key, value] of Object.entries(
              error.response.data.errors
            )) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "error",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                  text: value,
                },
              });
            }
          });
      }
    );

    return {
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      onSubmit,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
